import Api from './Api'

export default {
  register(credentials) {
    return Api().post('register', credentials)
  },
  login(credentials) {
    return Api().post('login', credentials)
  },
  forgotpassword(credentials) {
    return Api().post('forgot_password', credentials)
  },
  resetpassword(credentials) {
    return Api().post('reset_password', credentials)
  },
}
